<template>
  <div>
    <div class="page-top">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <span slot="label">
            <span class="lab-span">人员名称</span>
          </span>
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <span slot="label">
            <span class="lab-span">日期</span>
          </span>
          <el-date-picker
            v-model="searchForm.allTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <span slot="label">
            <span class="lab-span">报警类型</span>
          </span>
          <el-select v-model="searchForm.sosType" placeholder="请输入" filterable class="einp" clearable>
            <el-option v-for="item in sosType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="searchBtn" @click="searchOnRefer"
            >查询</el-button
          >
          <el-button type="warning" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <template v-if="personnelTotal != 0">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%; margin-top: 20px; margin-bottom: 20px"
          :height="$store.state.tabHeight"
        >
          <el-table-column type="index" label="序号" />
          <el-table-column align="center" prop="userName" label="人员名称" />
          <el-table-column align="center" prop="code" label="设备编号" />
          <el-table-column align="center" label="报警类型">
            <template slot-scope="scope">
              {{
                scope.row.sosType
                  ?( sosType.find((item) => item.value == scope.row.sosType)
                    ? sosType.find((item) => item.value == scope.row.sosType)
                        .label
                    : "-")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sosTime" label="报警时间" />
          <el-table-column align="center" prop="address" label="报警位置" />
          <el-table-column
            fixed="right"
            align="center"
            prop="address"
            label="操作"
            width="300px"
          >
            <template slot-scope="scope">
              <el-button @click="detail(scope.row)" type="warning" size="small"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="personnelTotal"
          :page.sync="searchForm.current"
          :limit.sync="searchForm.size"
          @pagination="personnelPage"
        />
      </template>

      <div class="nullDate" v-else>
        <img src="@/assets/nullDate.png" style="width: 260px" />
      </div>
    </div>
    <SosInfo
      v-if="detailVisible"
      :detailData="detailData"
      ref="sosInfo"
      :sosType="sosType"
      @closeInfo="closeInfo"
    />
  </div>
</template>
<script>
import Pagination from "../../../components/Pagination";
import Map from "@/components/map";
import SosInfo from "./components/info";
export default {
  components: {
    Pagination,
    Map,
    SosInfo,
  },
  data() {
    return {
      // 表格参数
      searchForm: {
        current: 1,
        size: 10,
      },
      tableData: [],
      // 分页参数
      personnelTotal: 0,
      // 错误信息列表
      errorList: null,
      detailVisible: false,
      detailData: {},
      sosType: [],
    };
  },
  filters: {},
  methods: {
    // 获取字典数据
    getDictionar(code) {
      this.$http
        .post(`/api/system/web/dict/dictionary?codes=${code}`)
        .then((res) => {
          if (res.data.code === 200) {
            const {
              data: { data },
            } = res;
            this.sosType = data.CAP_SOS_TYPE;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 分页
    personnelPage(data) {
      this.searchForm.current = data.page;
      this.searchForm.size = data.limit;
      this.onRefer();
    },

    // 搜索
    searchOnRefer() {
      this.searchForm.current = 1;
      this.onRefer();
    },
    // 重置
    reset() {
      console.log("重置");
      this.searchForm = {
        current: 1,
        size: 10,
      };
      this.onRefer();
    },

    // 获取人员方法
    onRefer() {
      const data = JSON.parse(JSON.stringify(this.searchForm));
      data.start = this.searchForm.allTime
        ? this.searchForm.allTime[0].getTime()
        : "";
      data.end = this.searchForm.allTime
        ? this.searchForm.allTime[1].getTime() + 24 * 60 * 60 * 1000 - 1000
        : "";
      this.$http.post("/api/cap/web/sos/getCapSosPage", data).then((res) => {
        if (res.data.success) {
          const {
            data: { data },
          } = res;
          this.tableData = data.records ?? []
          // this.$set(this, 'tableData', data.records ?? [])
          this.personnelTotal = data.total ?? 0;
          this.$forceUpdate()
          this.$nextTick(() => {
            if (this.personnelTotal > 0 && this.$refs.multipleTable) {
              this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 报警详情
    detail(row) {
      this.detailData = row;
      this.detailVisible = true;
      this.detailData.point = [row.ypoint.toFixed(6), row.xpoint.toFixed(6)];
      this.$nextTick(() => {
        this.$refs.sosInfo.init();
      });
    },
    // 详情关闭
    closeInfo() {
      this.detailVisible = false;
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getDictionar("CAP_SOS_TYPE");
      this.onRefer();
    });
  },
};
</script>
<style lang="scss" scoped>
.nullDate {
  width: 100%;
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchBtn {
  margin-left: 15px;
}
</style>
